export const findParam = ({ locationSearch, key }) => {
	const param = locationSearch
		?.split('&')
		?.find((item) => item.includes(`${key}=`))
		?.split(`${key}=`)[1];
	return encodeURIComponent(param);
};
